// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"352":"89013733dad766244082","544":"9ebd5cbc071c2d3f5cf7"}[chunkId] + ".css";
};